import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

const tableId = 'tableProgressiveBonuses';
const tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

const COLUMN_INDEX = {
    BonusName: 1,
    Status: 3,
}

const FILTER_DELIM = '-delim-';

export interface DashBoardPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        DetailsLink: string;
    }
}

export class DashBoardPage extends PageBase<DashBoardPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    private _filterBonus: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;

    constructor(options: DashBoardPageOptions) {
        super(options);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[100, 200, 300, -1], [100, 200, 300, "All"]],
            columns: [
                {
                    data: 'Id',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnId${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Name',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBonusName${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "Created",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: "Status",
                    render: (data: any, type: any, rowData: any) => {
                        return `<span id='spnStatus${rowData.Id}'>${data}</span>`;
                    }
                },
                {
                    data: 'Currencies',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCurrencies${rowData.Id}'>${data}</span>`)
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._form = Utils.getJQueryById("formProgressiveBonuses");
        this._btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        this._filterBonus = new MultiSelectApi('filterBonus');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._table = new Datatable(tableId, this._tableOptions);
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.BonusName).search(filterBonus);

        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Status).search(filterStatus);

        return true;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterBonus.selectAll();
        this._filterStatus.selectAll();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/DashBoardPage.ts
 **/